import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Link, Redirect } from 'react-router-dom'
import CalendarHeatmap from 'react-calendar-heatmap';
import { langs } from '../../common/config'
import { loadUser, clearUser, followUser, updateMe } from '../../common/users/actions'
import { loadLessons } from '../../common/lessons/actions'
import { loadNotifications } from '../../common/notifications/actions'
import { LessonsList, Button } from '../components'
import { TextInput, SelectInput } from '../components/fields'

import 'react-calendar-heatmap/dist/styles.css';

class UserPage extends React.Component {
  state = {
    name: '',
    userLanguage: '',
    isChanged: false,
  }

  componentDidMount() {
    const { match, loadUser, lessons, loadLessons, loadNotifications } = this.props
    this.userId = this.props.match.params.id
    if (this.userId) {
      loadUser(match.params.id)
    } else if (!this.userId && !lessons.size) {
      loadLessons()
    }
    // loadNotifications()
  }

  componentWillReceiveProps(nextProps) {
    const { viewer } = nextProps

    if (!this.state.name && viewer) {
      this.setState({ name: viewer.name, userLanguage: viewer.userLanguage })
    }
  }

  componentWillUnmount() {
    if (this.userId) {
      this.props.clearUser()
    }
  }

  updateUser(field, value) {
    this.setState({
      [field]: value,
      isChanged: true,
    })
  }

  render() {
    const { userProfile, viewer, lessons, followUser, intl, updateMe } = this.props
    let user = null
    let userLessons = null
    const isUserProfile = this.userId && userProfile

    if (isUserProfile) {
      if (userProfile._id === viewer._id) {
        return <Redirect to="/app/user" />
      }
      user = (userProfile && userProfile.toJS())
      userLessons = user.userLessons
    } else if (!this.userId && lessons) {
      user = viewer
      userLessons = lessons.toJS()
    }

    if (!user) return null

    return (
      <div className="user-page">
        <div className="left-panel float-left">
          <img className="user-image" src={user.picture || '/assets/images/placeholder-face-big.png'} alt="Profile" />
          <p>{intl.formatMessage(messages.email)}: {user.email}</p>
          
          {
            !isUserProfile ?
              <React.Fragment>
                <TextInput
                  value={this.state.name}
                  onChange={e => this.updateUser('name', e.target.value)}
                />
                <SelectInput
                  value={this.state.userLanguage}
                  options={langs.map(lang => ({
                    key: lang.key,
                    label: lang.label,
                  }))}
                  onChange={e => this.updateUser('userLanguage', e.target.value)}
                />
                <Button
                  disabled={!this.state.isChanged}
                  className="disable-spacing-left spacing-top"
                  positive
                  onClick={() => {
                    updateMe({ 
                      name: this.state.name,
                      userLanguage: this.state.userLanguage,  
                    })
                    this.setState({ isChanged: false })
                  }}
                >
                  {intl.formatMessage(messages.save)}
                </Button>
              </React.Fragment>
            :
              <React.Fragment>
                <h3>
                  <b>{user.name}</b>
                </h3>
              </React.Fragment>
          }
          
          {/*
            !this.userId && viewer.authType === 'LOCAL' &&
            <p>{intl.formatMessage(messages.matureLanguage)}: {user.userLanguage}</p>
            <p>{intl.formatMessage(messages.teachingSubject)}: {user.learningLanguage}</p>
            <Link to="/app/change-password">Change password</Link> 
          */}
          {/*
            <h3>{intl.formatMessage(messages.followers)}:</h3>
            <div className="users-list">
              {
                user.followers.map(u => (
                  <div className="user-item" key={u.id}>
                    <Link to={`/app/user/${u._id}`}>
                      <img src="../../../assets/images/placeholder-face-big.png" alt="profile" />
                      <span>{u.name}</span>
                    </Link>
                  </div>
                ))
              }
            </div>
          */}
        </div>
        <div className="center-panel float-left">
          {
            !this.userId &&
            <div>
              <h3>{intl.formatMessage(messages.learningActivity)}:</h3>
              <CalendarHeatmap
                startDate={new Date('2020-06-01')}
                endDate={new Date()}
                values={
                  user.practices.map(practice => ({
                    date: practice, count: 1,
                  }))}
              />
              {/*
              <h3>{intl.formatMessage(messages.following)}:</h3>
              <div className="users-list">
                {
                  user.following && user.following.length ?
                    user.following.map(u => (
                      <div className="item-box user-item" key={u.id}>
                        <Link to={`/app/user/${u._id}`}>
                          <img src={u.picture || '/assets/images/placeholder-face-big.png'} alt="profile" />
                          <span>{u.name}</span>
                        </Link>
                      </div>
                    ))
                  :
                    <div className="item-box">
                      <p>
                        {intl.formatMessage(messages.noFollowing)} <Link to="/app/search">{intl.formatMessage(messages.searchFriends)}</Link>
                      </p>
                    </div>
                }
              </div>
              */}
            </div>
          }
          {
            isUserProfile &&
            <div>
              <h3>{intl.formatMessage(messages.exercises)}:</h3>
              {
                (!userLessons || !userLessons.length) &&
                <div className="item-box">
                  <p>{intl.formatMessage(messages.noPublicexercises)}</p>
                </div>
              }
              <LessonsList lessons={userLessons} />
            </div>
          }
          {
            isUserProfile && !viewer.following.some(u => String(u._id) === String(user.id)) &&
            <Button
              positive
              onClick={() => followUser(user._id)}
            >
              {intl.formatMessage(messages.follow)}
            </Button>
          }
        </div>
      </div>
    )
  }
}

UserPage.defaultProps = {
  match: null,
  lessons: null,
  userProfile: null,
  viewer: null,
}

UserPage.propTypes = {
  userProfile: PropTypes.object,
  viewer: PropTypes.object,
  lessons: PropTypes.object,
  loadNotifications: PropTypes.func.isRequired,
  loadLessons: PropTypes.func.isRequired,
  loadUser: PropTypes.func.isRequired,
  clearUser: PropTypes.func.isRequired,
  followUser: PropTypes.func.isRequired,
  updateMe: PropTypes.func.isRequired,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    userProfile: state.users.current,
    lessons: state.lessons.all,
    notifications: state.notifications.all,
  }), { loadUser, clearUser, loadLessons, loadNotifications,
    followUser, updateMe }),
  injectIntl,
)

export default enhance(UserPage)

const messages = defineMessages({
  email: {
    id: 'user.page.email',
    defaultMessage: 'Email',
  },
  save: {
    id: 'user.page.save',
    defaultMessage: 'Uložiť',
  },
  matureLanguage: {
    id: 'user.page.matureLanguage',
    defaultMessage: 'Rodný jazyk',
  },
  teachingSubject: {
    id: 'user.page.teachingSubject',
    defaultMessage: 'Rodný jazyk',
  },
  learningActivity: {
    id: 'user.page.learningActivity',
    defaultMessage: 'Aktivita',
  },
  followers: {
    id: 'user.page.followers',
    defaultMessage: 'Sledujú Vás',
  },
  following: {
    id: 'user.page.following',
    defaultMessage: 'Sledujete',
  },
  noFollowing: {
    id: 'user.page.noFollowing',
    defaultMessage: 'Zatiaľ nesledujete žiadneho užívateľa.',
  },
  searchFriends: {
    id: 'user.page.searchFriends',
    defaultMessage: 'Hľadať známych.',
  },
  exercises: {
    id: 'user.page.exercises',
    defaultMessage: 'Hľadať známych.',
  },
  noPublicexercises: {
    id: 'user.page.noPublicexercises',
    defaultMessage: 'Užívateľ nemá žiadne verejné cvičenia.',
  },
  follow: {
    id: 'user.page.follow',
    defaultMessage: 'Sledovať',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/UserPage.js